<template lang="pug">
    TransferPaging(
                ref="paging"
                :dataList="dataList"
                :selectedData="selectedData"
                :listTitle="listTitle"
                :listStyle="listStyle"
                :pageSize="pageSize"
                :pageText="['Prev', 'Next']"
                :searchPlaceholder="'Search'"
                :noDataText="$t('main.tableNoDataText')"
                :maxSelectedItemsCount="formItem.maxItemsCount"
                :isHighlight="true"
                @onChange="onChange"
            )
</template>
<script>
import { queryParamsFieldsCompletion } from "@/libs/rcmTableFieldsFunction";
export default {
    props: {
        value: {
            type: Array,
            default: function() {
                return [];
            }
        },
        formItem: {},
        formData: {}
    },
    data() {
        return {
            dataList: [],
            selectedData: [],
            listStyle: {
                width: "40%",
                height: "450px"
            },
            queryParamsFields: this.formItem.queryParamsFields,
            pageSize: this.formItem.pageSize || 300
        };
    },
    mounted() {
        if (this.isRemoteOptions) {
            // 在意的欄位中, 只要一人符合 queryIf 條件, 即可以在 mounted 時獲取選項
            // 亦即: 所有在意的欄位都不符合時, 則不能在 mounted 時獲取選項
            let hasSomeFieldsMatch = this.queryParamsFields.some(field =>
                field.queryIf(this.formData[field.fieldName])
            );
            let canGetOptions = this.queryParamsFields.length == 0 || hasSomeFieldsMatch;
            if (canGetOptions) this.getRemoteOption(this.queryParams);
        } else {
            this.dataList = this.createDataList(this.formItem.options);
            this.selectedData = this.createSelectedData(this.value, this.formItem.options);
        }
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);

        // 監聽需要注意的欄位
        this.queryParamsFields.forEach(field => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function() {
                    return this.formData[fieldName];
                },
                function(newVal, oldVal) {
                    // console.log(`${this.formItem.key}: ${fieldName} changed from ${oldVal} to ${newVal}`);
                    if (queryIf(newVal)) {
                        this.$emit("input", this.formItem.defaultVal);
                        this.getRemoteOption(this.queryParams);
                    }
                },
                { deep: true }
            );
        });
    },
    methods: {
        onChange(newVal) {
            this.$emit("input", newVal);
        },
        async getRemoteOption(queryParams) {
            let remoteOptions = await this.formItem.remoteOptions(queryParams);
            this.dataList = this.createDataList(remoteOptions);
            this.selectedData = this.createSelectedData(this.value, remoteOptions);
        },
        // 因為組件需求 id 欄位, 新增兩個適配方法
        createDataList(options) {
            let dataList = options.map(e => {
                e.id = e.value;
                e.label = e.label ? e.label : e.value;
                e.disabled =
                    this.formItem.disabledOptions && this.formItem.disabledOptions.some(d => d.value == e.value);

                return e;
            });
            return dataList;
        },
        createSelectedData(value, options) {
            let selectedData = options
                .filter(e => value.includes(e.value))
                .map(e => {
                    e.id = e.value;
                    return e;
                });
            return selectedData;
        }
    },
    computed: {
        listTitle() {
            let maxItemsCount = 0;
            maxItemsCount = parseInt(this.formItem.maxItemsCount);
            let valueLength = this.value.length;
            if (maxItemsCount == undefined) return ["Assigned", "Available"];
            return [`Assigned Limit: ${valueLength}/${maxItemsCount}`, "Available"];
        },
        isRemoteOptions() {
            return typeof this.formItem.remoteOptions == "function";
        },
        queryParams() {
            let queryParams = {};
            this.queryParamsFields.forEach(field => {
                let { fieldName } = field;
                queryParams[fieldName] = this.formData[fieldName];
            });
            return queryParams;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Transfer.vue